<div class="row h-100 ">
    <div class="col-md-12 my-auto">
  <div class="row justify-content-center">
    <div class="col-md-3">
        <div class="card">
<h2 class="h4 mt-0 mb-1">Reset Password?</h2>
<p [tcColor]="'#8f8f90'">Reset with new password</p>

<reset-form></reset-form>

</div>
</div>
</div>
</div>